var _title, _desc, _g;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgWaiterTable = function SvgWaiterTable(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "796px",
    height: "796px",
    viewBox: "0 0 796 796",
    ref: svgRef
  }, props), title === undefined ? _title || (_title = /*#__PURE__*/React.createElement("title", null, "Oval")) : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Color-Styles",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Oval"
  }, /*#__PURE__*/React.createElement("circle", {
    stroke: "#979797",
    fill: "#F55000",
    opacity: 0.2,
    cx: 398,
    cy: 398,
    r: 397.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "waiter-(2)",
    transform: "translate(200.000000, 144.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M413.55,222.009 L301.382,346.909 L234.103,285.996 L234.103,503.769 L53.01,503.769 L53.01,391.359 L8.823,391.359 L8.823,254.101 C8.823,229.856 28.48,210.212 52.724,210.201 L216.026,210.201 C227.671,210.201 238.833,214.788 247.075,223.019 L259.137,235.081 L301.601,277.556 L357.136,222.01 L413.55,222.01 L413.55,222.009 Z",
    id: "Path",
    fill: "#E0E0E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.139,235.081 C219.09,310.679 139.595,362.186 48.071,362.186 C34.703,362.186 8.823,362.186 8.823,362.186 L8.823,254.101 C8.823,229.856 28.48,210.212 52.724,210.201 L216.026,210.201 C227.671,210.201 238.833,214.788 247.075,223.019 L259.139,235.081 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("polygon", {
    id: "Path",
    fill: "#898890",
    fillRule: "nonzero",
    points: "166.605 235.421 166.605 189.325 127.093 200.534 87.582 189.325 87.582 235.421 127.093 224.989"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M174.836,246.108 L127.093,233.503 L79.35,246.108 L79.35,178.433 L127.093,191.978 L174.836,178.433 L174.836,246.108 Z M127.093,216.476 L158.373,224.734 L158.373,200.216 L127.093,209.09 L95.813,200.216 L95.813,224.734 L127.093,216.476 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#F55000",
    fillRule: "nonzero",
    x: 85.752,
    y: 335.385,
    width: 82.502,
    height: 131.704
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    x: 107.341,
    y: 353.955,
    width: 16.463,
    height: 16.463
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.483,195.998 L458.637,195.998 C458.637,163.698 441.142,135.228 415.076,119.829 C402.015,112.091 386.804,107.646 370.56,107.646 C321.917,107.646 282.483,147.509 282.483,195.998 Z",
    id: "Path",
    fill: "#C6C5CA",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M282.483,195.998 L297.212,195.998 C349.894,195.998 415.076,149.814 415.076,119.829 C402.015,112.091 386.804,107.646 370.56,107.646 C321.917,107.646 282.483,147.509 282.483,195.998 Z",
    id: "Path",
    fill: "#E0E0E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M466.518,187.771 C462.559,140.953 425.159,103.549 378.429,99.743 L378.429,85.7 L361.966,85.7 L361.966,99.809 C315.578,103.945 278.547,141.199 274.608,187.771 L260.993,187.771 L260.993,204.234 L274.255,204.234 L466.872,204.234 L479.403,204.234 L479.403,187.771 L466.518,187.771 L466.518,187.771 Z M291.135,187.771 C295.257,147.446 329.306,115.882 370.563,115.882 C411.82,115.882 445.868,147.446 449.991,187.771 L291.135,187.771 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M328.491,178.99 L312.028,178.99 C312.028,151.99 333.938,130.023 360.868,130.023 L360.868,146.486 C343.016,146.487 328.491,161.068 328.491,178.99 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#000000",
    fillRule: "nonzero",
    x: 53.01,
    y: 383.127,
    width: 32.743,
    height: 16.463
  }), /*#__PURE__*/React.createElement("path", {
    d: "M353.732,213.78 L301.601,265.912 L252.896,217.203 L241.254,228.843 L301.602,289.191 L360.552,230.241 L395.096,230.241 L300.784,335.262 L225.873,267.442 L225.873,495.536 L61.242,495.536 L61.242,383.132 L17.061,383.132 L17.061,254.102 C17.061,234.437 33.059,218.437 52.723,218.432 L52.719,201.969 C23.979,201.976 0.598,225.362 0.598,254.102 L0.598,399.595 L44.779,399.595 L44.779,512 L242.335,512 L242.335,304.556 L301.988,358.562 L432.007,213.78 L353.732,213.78 Z",
    id: "Path",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M44.778,286 L44.778,351.851 L77.521,351.851 L77.521,475.325 L176.482,475.325 L176.482,399.595 L217.64,399.595 L217.64,335.388 L176.482,335.388 L176.482,327.158 L77.521,327.158 L77.521,335.388 L61.241,335.388 L61.241,286 L44.778,286 Z M201.177,351.851 L201.177,383.132 L176.482,383.132 L176.482,351.851 L201.177,351.851 Z M93.984,343.621 L160.019,343.621 L160.019,458.862 L93.984,458.862 L93.984,343.621 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M472.817,115.241 L456.354,115.241 L456.354,100.424 L472.817,100.424 L472.817,115.241 Z M472.817,83.961 L456.354,83.961 L456.354,67.498 L472.817,67.498 L472.817,83.961 Z M472.817,51.035 L456.354,51.035 L456.354,34.572 L472.817,34.572 L472.817,51.035 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M441.537,67.498 L425.074,67.498 L425.074,51.035 L441.537,51.035 L441.537,67.498 Z M441.537,34.572 L425.074,34.572 L425.074,18.109 L441.537,18.109 L441.537,34.572 Z",
    id: "Shape",
    fill: "#F55000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.611,49.389 L392.148,49.389 L392.148,32.926 L408.611,32.926 L408.611,49.389 Z M408.611,16.463 L392.148,16.463 L392.148,0 L408.611,0 L408.611,16.463 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M193.955,102.532 C193.955,138.893 164.464,168.384 128.103,168.384 C101.751,168.384 79.021,152.909 68.496,130.541 C64.49,122.046 62.251,112.541 62.251,102.532 C62.251,66.16 91.731,36.68 128.103,36.68 C140.505,36.68 152.106,40.115 162.006,46.086 C181.147,57.588 193.955,78.562 193.955,102.532 Z",
    id: "Path",
    fill: "#E0E0E2",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M168.251,74.084 C168.251,110.456 138.771,139.936 102.399,139.936 C89.997,139.936 78.396,136.501 68.496,130.541 C64.49,122.046 62.251,112.541 62.251,102.532 C62.251,66.16 91.731,36.68 128.103,36.68 C140.505,36.68 152.106,40.115 162.006,46.086 C166.012,54.58 168.251,64.074 168.251,74.084 Z",
    id: "Path",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.103,176.615 C99.539,176.615 73.216,159.905 61.047,134.045 C56.385,124.157 54.019,113.552 54.019,102.531 C54.019,61.681 87.252,28.447 128.103,28.447 C141.577,28.447 154.772,32.108 166.258,39.036 C188.415,52.35 202.187,76.683 202.187,102.531 C202.187,143.382 168.953,176.615 128.103,176.615 Z M128.103,44.911 C96.332,44.911 70.482,70.759 70.482,102.532 C70.482,111.107 72.318,119.35 75.941,127.03 C85.411,147.153 105.884,160.152 128.102,160.152 C159.873,160.152 185.723,134.304 185.723,102.531 C185.723,82.123 175.272,63.66 157.766,53.141 C148.835,47.755 138.582,44.911 128.103,44.911 Z",
    id: "Shape",
    fill: "#000000",
    fillRule: "nonzero"
  }))))));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgWaiterTable, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/waiter-table.cdcd0dbe.svg";
export { ForwardRef as ReactComponent };